import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MailService } from '@ascschool/services/mail/mail.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
@Component({
  selector: 'app-add-tag',
  templateUrl: './add-tag.component.html',
  styleUrls: ['./add-tag.component.scss']
})
export class AddTagComponent implements OnInit {
  @ViewChildren('label') labelElement:any;
  @Input() value: any;
  validateForm: FormGroup;
  idMail: number[] = [];
  tagId: number;
  tags = [];
  colorSelected: string;
  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef,
    private service: MailService,
    private msg: NzMessageService, 
    public utilsService: UtilsService,
  ) { 
    this.validateForm = this.fb.group({
      id: this.fb.control(0),
    });
  }
  close(){
    this.modal.destroy();
  }
  add(){
    if(this.validateForm.valid){
      this.service.setTag(this.validateForm.controls.id.value, this.idMail).subscribe(
        () => {
          this.msg.success('Cài đặt nhãn thành công!');
          this.modal.destroy(true);
        },()=>{
          this.msg.error('Cài đặt nhãn thất bại vui lòng thử lại.');
        });
    }else{
      this.utilsService.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }

  }
  getTags(){
    this.service.getTagPaging({ PageIndex: 1, PageSize: 100 }).subscribe((res)=>{
      this.tags = res.results;
    });
  }
  checkMode(){
    if(Array.isArray(this.value)){
      this.idMail = this.value;
    }else{
      this.idMail.push(this.value.id);
      this.validateForm.controls.id.setValue(this.value.tagId);
      this.colorSelected = this.value.color;
    }
  }
  ngOnInit() {
    this.getTags();
    this.checkMode();
    this.checkValueSelected();
  }
  checkValueSelected(){
    this.validateForm.valueChanges.subscribe(x => {
      this.checkColorTag(x.id);
  })
  }
  checkColorTag(id){
    this.tags.forEach(tag=>{
      if(tag.id === id){
        this.colorSelected = tag.color;
      }
    })
  }
}
